var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home_3388840",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_3388840-2",
    "data-name": "home_3388840",
    d: "M23.619,10.849,12.519.209a.75.75,0,0,0-1.038,0L.37,10.86a1.267,1.267,0,0,0-.37.89A1.252,1.252,0,0,0,1.25,13H3v9.5A1.5,1.5,0,0,0,4.5,24H8.75a.75.75,0,0,0,.75-.75v-6.5a.251.251,0,0,1,.25-.25h4.5a.251.251,0,0,1,.25.25v6.5a.75.75,0,0,0,.75.75H19.5A1.5,1.5,0,0,0,21,22.5V13h1.75A1.252,1.252,0,0,0,24,11.75,1.277,1.277,0,0,0,23.619,10.849Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHomeIcon);
export default __webpack_public_path__ + "static/media/dashboard_home_Icon.2cda9a68e9f855f91ce9bed55241b069.svg";
export { ForwardRef as ReactComponent };